module.exports = __webpack_public_path__ + "static/media/stay-productive-remote.47211c0b.png";